// src/index.ts
var isBrowser = typeof window !== "undefined" && typeof window.btoa !== "undefined";
function base64urlEncode(data) {
  let base64;
  if (isBrowser) {
    if (typeof data === "string") {
      base64 = btoa(data);
    } else {
      base64 = btoa(String.fromCharCode(...Array.from(data)));
    }
  } else {
    if (typeof data === "string") {
      base64 = Buffer.from(data, "utf8").toString("base64");
    } else {
      base64 = Buffer.from(data).toString("base64");
    }
  }
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function base64urlDecode(str) {
  const base64 = str.replace(/-/g, "+").replace(/_/g, "/").padEnd(str.length + (4 - str.length % 4) % 4, "=");
  if (isBrowser) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  } else {
    return new Uint8Array(Buffer.from(base64, "base64"));
  }
}
function base64urlDecodeToString(str) {
  const bytes = base64urlDecode(str);
  if (isBrowser && typeof TextDecoder !== "undefined") {
    return new TextDecoder().decode(bytes);
  } else if (!isBrowser) {
    return Buffer.from(bytes).toString("utf8");
  } else {
    return String.fromCharCode(...bytes);
  }
}
function stringToBase64url(str) {
  if (isBrowser && typeof TextEncoder !== "undefined") {
    const bytes = new TextEncoder().encode(str);
    return base64urlEncode(bytes);
  } else if (!isBrowser) {
    return base64urlEncode(str);
  } else {
    return base64urlEncode(str);
  }
}
export {
  base64urlDecode,
  base64urlDecodeToString,
  base64urlEncode,
  stringToBase64url
};
//# sourceMappingURL=index.mjs.map